

const Body = () => {

    return (
        <div style={{height: 1000}}>
           
        </div>
    )


}

export default Body;